import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import ArrowBack from '@mui/icons-material/ArrowBack';

import thumbnail from '../../../_assets/thumbnail/sophia.webp';
import title from '../../../_assets/sophia-logo.webp';
import { Breadcrumb, BreadcrumbPath } from '../../../_shared/breadcrumb/Breadcrumb';
import { GameTrailer } from '../common/Game-trailer';

export function SophiaGame(): JSX.Element {
  const { t } = useTranslation();
  const history = useHistory();
  const breadcrumb: BreadcrumbPath[] = [
    {
      key: 'button.my-account',
      path: '/account/my-account',
    },
    {
      key: t('games.sophia'),
      path: '',
    },
  ];

  const back = (): void => {
    history.goBack();
  };

  return (
    <div className='game-container our-game-container'>
      <div className='our-game-background' />
      <img className='game-thumbnail' src={thumbnail} alt='Sophia Thumbnail' />
      <div className='banner'>
        <button type='button' className='btn btn-secondary back-btn' onClick={back}>
          <ArrowBack className='icon' />
          {t('button.back')}
        </button>
        <Breadcrumb paths={breadcrumb} />
        <img className='title' src={title} alt='title sophia' height={120} />
        <GameTrailer
          storesUrls={{
            steam: 'https://store.steampowered.com/app/2071500/Project_S/',
          }}
          youtubeUrl='https://www.youtube.com/embed/l6KZba1xGhk'
        />
      </div>
    </div>
  );
}
